// 260929-omp: shared "Other" detection + note length limit.
//
// The reject-reason Dropdown maps each option's `value` to its `label`
// (useBillManagement.js billrejectReasonDropdown), so the string emitted by
// the dropdown is the LABEL ("Other"). The same pattern below also matches
// the raw DB `value` ("other"), which satisfies the label-OR-value rule.
export const REJECTION_NOTE_MAX_LENGTH = 255;

const OTHER_PATTERN = /^others?$/i;

export function isOtherReason(value) {
  const trimmed = (value ?? '').toString().trim();
  return OTHER_PATTERN.test(trimmed);
}
